<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.ms_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="createTime">
            <label class="weui-form-preview__label">{{customLabel.createTime || "单据日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.createTime}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ms_departmentname">
            <label class="weui-form-preview__label">{{customLabel.ms_departmentname || "部门名称"}}</label>
            <em class="weui-form-preview__value">{{form.main.ms_departmentname}}</em>
          </div>
        </custom-layout>
      </div>

      <collapse class="form-preview weui-form-preview" :title="'明细（'+form.items.length+'条）'">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{item.md_detno}}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="md_macode">
              <label class="weui-form-preview__label">{{customLabel.md_macode || "分切单号"}}</label>
              <span class="weui-form-preview__value">{{item.md_macode}}</span>
            </div>
            <div class="weui-form-preview__item" slot="md_mmdetno">
              <label class="weui-form-preview__label">{{customLabel.md_mmdetno || "工单序号"}}</label>
              <span class="weui-form-preview__value">{{item.md_mmdetno}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_code">
              <label class="weui-form-preview__label">{{customLabel.pr_code || "产品"}}</label>
              <span
                class="weui-form-preview__value"
              >{{item.productDTO.pr_code}} {{item.productDTO.pr_detail}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.productDTO.pr_brand" slot="pr_brand">
              <label class="weui-form-preview__label">{{customLabel.pr_brand || "品牌"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_brand}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.productDTO.pr_orispeccode" slot="pr_orispeccode">
              <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_orispeccode}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.productDTO.pr_spec" slot="pr_spec">
              <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_spec}}</span>
            </div>
            <div class="weui-form-preview__item" slot="md_qty">
              <label class="weui-form-preview__label">{{customLabel.md_qty || "报废数量"}}</label>
              <span class="weui-form-preview__value">{{item.md_qty}} {{item.productDTO.pr_unit}}</span>
            </div>
            <!-- <div class="weui-form-preview__item" slot="pd_qty_extra">
              <label class="weui-form-preview__label">{{customLabel.pd_qty_extra || "辅助数量"}}</label>
              <span class="weui-form-preview__value">{{item.pd_qty_extra}} {{item.productDTO.pr_unit_extra}}</span>
            </div> -->
            <div class="weui-form-preview__item" slot="md_batchcode">
              <label class="weui-form-preview__label">{{customLabel.md_batchcode || "来源批次号"}}</label>
              <span class="weui-form-preview__value">{{item.md_batchcode}}</span>
            </div>
            <div class="weui-form-preview__item" slot="md_reason">
              <label class="weui-form-preview__label">{{customLabel.md_reason || "报废原因"}}</label>
              <span class="weui-form-preview__value">{{item.md_reason}}</span>
            </div>
            <div class="weui-form-preview__item" slot="md_price">
              <label class="weui-form-preview__label">{{customLabel.md_price || "成本单价(元)"}}</label>
              <span class="weui-form-preview__value">{{numberFormat(item.md_price,'#,##0.####')}}</span>
            </div>
            <div class="weui-form-preview__item" slot="md_total">
              <label class="weui-form-preview__label">{{customLabel.md_total || "金额(元)"}}</label>
              <span class="weui-form-preview__value">{{numberFormat(item.md_total,'#,##0.00')}}</span>
            </div>
            <div class="weui-form-preview__item" slot="md_remark">
              <label class="weui-form-preview__label">{{customLabel.md_remark || "备注"}}</label>
              <span class="weui-form-preview__value">{{item.md_remark}}</span>
            </div>
          </custom-layout>
        </div>
      </collapse>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{form.main.ms_remark}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import Collapse from "@/components/Collapse.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    Collapse
  },
  data() {
    return {
      baseUrl: "/api/make/makescrap",
      caller: "MakeCutScrap",
      xtype: "make-makecutscrap-formpanel",
    };
  }
};
</script>